import { Injectable } from '@angular/core';

import { ApiService }         from '../../app-lite/api/api.service';
import { ResetPasswordModel } from './typings/password.reset';

@Injectable({
  providedIn: 'root'
})
export class PasswordsService {
  constructor (
    private apiService: ApiService
  ) {}

  requestReset ( email : string ) : ng.IPromise<any> {
    return this.apiService.post('/users/request_reset_email', email, 'email');
  }

  reset ( user : ResetPasswordModel ) : ng.IPromise<any> {
    return this.apiService.post('/users/reset_password', user, null, null, {
      bypass: true
    });
  }
}
